import React from "react";
import styled from "styled-components";
import Container from "../../Components/Container";
import LogoTransparent from "../../assets/images/logo-transparent.png";
import Macbook from "../../assets/images/macbook.svg";

const Title = styled.h1`
  font-weight: 700;
  font-size: 40px;
  color: #000000;
  line-height: 69px;
`;

const Info = styled.p`
  font-weight: 300;
  font-size: 20px;
  color: #000000;
  line-height: 30px;
  margin-top: 40px;
`;

const Painel = () => {
  
  const isMobile = window.innerWidth <= 768;

  return (
    <Container
      style={{
        textAlign: "center",
        paddingBottom: "120px",
        background: "#ffffff",
        position: "relative",
        overflow: "hidden",
      }}
      id="section-4"
    >
      <img
        src={LogoTransparent}
        style={{
          position: "absolute",
          left: "0px",
          top: "120px",
          maxWidth: isMobile ? "30%" : "100%",
          zIndex: "0",
        }}
        alt="logo"
      />
      <div style={{ zIndex: 99, position: "relative" }}>
        <Title>
          Você acompanha em <span style={{ color: "#E4DA1B" }}>tempo real</span>
        </Title>
        <img src={Macbook} alt="macbook" />
        <Info>
          O <span style={{fontWeight: 700}}>Alfred</span> tem módulos de agendamento, restaurante e delivery prontos.
        </Info>
      </div>
    </Container>
  );
};

export default Painel;
